export class VehicleRequest {
    vehicleId: number;
    
    constructor(vehicleId: number){ 
            this.vehicleId = vehicleId;
        }
}